/** @module csi/widget/DropDownMenu */
define([
	"dojo/_base/declare",
	"dijit/DropDownMenu",
	"csi/widget/_DropDownMenuMixin"
], function(declare,DropDownMenu,DropDownMenuMixin) {
	/**
	 * Mixin to Add class to style left or right menu
	 */
	return declare([DropDownMenu,DropDownMenuMixin], { });
});